import {DropdownOptionProps} from '../../../models/DropdownProps';
import {SELECT_TYPE} from '../../../utils/DropdownOptionPropsUtils';

export const mainFileTypeResource: DropdownOptionProps[] = [
    {
        name: SELECT_TYPE, value: SELECT_TYPE
    },
    {
        name: 'archive', value: 'archive'
    },
    {
        name: 'audio', value: 'audio'
    },
    {
        name: 'document', value: 'document'
    },
    {
        name: 'image', value: 'image'
    },
    {
        name: 'other', value: 'other'
    },
    {
        name: 'presentation', value: 'presentation'
    },
    {
        name: 'sheet', value: 'sheet'
    },
    {
        name: 'video', value: 'video'
    }
];